import * as React from 'react';
import * as main from '../../main.module.scss';
import * as res from './style.module.scss';
export const ResultsAfter = ({ widgetFree }) => {
  return (
    <section className={res.res}>
      <div className="container">
        <h2 className={main.title}>Результаты марафона</h2>
        <p className={main.subtitle}>После марафона вы узнаете:</p>
        <ul>
          <li>
            <a href="#resForm">
              <img
                src="https://fs.advance.ru/landing-pages/marathon/marafon_motivacii_i_obuchenija_detej_2025/rezult-1.png"
                alt=""
              />
              <p>Почему только 2% людей развиваются и регулярно учатся после 25 лет</p>
            </a>
          </li>
          <li>
            <a href="#resForm">
              <img
                src="https://fs.advance.ru/landing-pages/marathon/marafon_motivacii_i_obuchenija_detej_2025/Rezult-2.png"
                alt=""
              />
              <p>Как сделать обучение регулярной привычкой, которая даёт, а не отнимает энергию</p>
            </a>
          </li>
          <li>
            <a href="#resForm">
              <img
                src="https://fs.advance.ru/landing-pages/marathon/marafon_motivacii_i_obuchenija_detej_2025/Rezult-3.png"
                alt=""
              />
              <p>Как освоить любую профессию или выучить любой язык на базовом уровне за три месяца без зубрежки</p>
            </a>
          </li>
          <li>
            <a href="#resForm">
              <img
                src="https://fs.advance.ru/landing-pages/marathon/marafon_motivacii_i_obuchenija_detej_2025/Rezult-4.png"
                alt=""
              />
              <p>Как запоминать любое количество информации без насилия над собой</p>
            </a>
          </li>
          <li>
            <a href="#resForm">
              <img
                src="https://fs.advance.ru/landing-pages/marathon/marafon_motivacii_i_obuchenija_detej_2025/Rezult-5.png"
                alt=""
              />
              <p>Какие навыки являются приоритетными для карьеры, здоровья и личной жизни и как их развивать</p>
            </a>
          </li>
          <li>
            <a href="#resForm">
              <img
                src="https://fs.advance.ru/landing-pages/marathon/marafon_motivacii_i_obuchenija_detej_2025/Rezult-6.png"
                alt=""
              />
              <p>Как с запасом наверстать упущенное время и возможности</p>
            </a>
          </li>
          <li>
            <a href="#resForm">
              <img
                src="https://fs.advance.ru/landing-pages/marathon/marafon_motivacii_i_obuchenija_detej_2025/Rezult-7.png"
                alt=""
              />
              <p>Как сохранить ясную память, мотивацию и запас сил</p>
            </a>
          </li>
        </ul>
        <div className={res.reg} id={'resForm'}>
          <div className={res.info}>
            <h3>Получите доступ к&nbsp;марафону</h3>
            <div className={res.priceWrap}>
              <p className={res.text}>Запишитесь сейчас и&nbsp;получите доступ к&nbsp;марафону бесплатно</p>
            </div>
          </div>
          <div className={res.form}>
            <h3>Заполните поля и мы отправим доступ на почту</h3>
            {widgetFree}
          </div>
        </div>
      </div>
    </section>
  );
};
